module.exports = __webpack_public_path__ + "img/wanderSaneBadge.f91629ba.svg";